import React, { useRef } from "react";
import "../css/faqs.css";
import FaqItem from "./FAQItem.js";

const FAQs = () => {
  let faqCont = useRef();
  let faqData = [
    {
      faqQues: "How long does it take to ship my order?",
      faqAns:
        "Orders are usually shipped within 1-2 business days after placing the order.",
    },
    {
      faqQues: "What payment methods do you accept?",
      faqAns:
        "Orders are usually shipped within 1-2 business days after placing the order.",
    },
    {
      faqQues: "What shipping options do you have?",
      faqAns:
        "Orders are usually shipped within 1-2 business days after placing the order.",
    },
    {
      faqQues: "How do I make changes to an existing order?",
      faqAns:
        "Orders are usually shipped within 1-2 business days after placing the order.",
    },
    {
      faqQues: "When will my order arrive?",
      faqAns:
        "Orders are usually shipped within 1-2 business days after placing the order.",
    },
  ];
  
  return (
    <section id="faqs">
      <div>
        <div>
          <span>FAQ</span>
          <h2>Frequently Asked Questions</h2>
          <p>
            Flex is the only saas business platform that lets you run your
            business on one platform, seamlessly across all digital channels.
          </p>
        </div>
        <div ref={faqCont}>
          {faqData.map((faqItem, index) => {
            return (
              <FaqItem
                key={index}
                faqQues={faqItem.faqQues}
                faqAns={faqItem.faqAns}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
